import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";
import { encodeQueryValue } from "./queryString";
import { withoutLegacyAuthority } from "./requestPayload";
import { catalogLegacyQuery, catalogListLimit, localCatalogAction } from "./catalogRequest";

const API_URL = config.API_URL;
const hasValue = (value) => value !== undefined && value !== null && String(value).trim() !== "";

const create = (values) => {
  const action = "afterlogin/services/store";
  return axios.post(API_URL + action, withoutLegacyAuthority(values), { headers: authHeader() });
};

const update = (values) => {
  const data = withoutLegacyAuthority(values);
  const action = "afterlogin/services/update/" + values.id;
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const view = (values) => {
  const sort = values && values.sort;
  const dropdown = values && values.dropdown ? values.dropdown : "";
  const result = values && values.result ? values.result : "";
  const fromPosition = values && values.fromPosition;
  const toPosition = values && values.toPosition;
  const pagetype = values && values.pagetype ? values.pagetype : "";
  const formName = values && values.formName ? values.formName : "";
  const q = typeof (values && values.q) === "string" ? values.q : catalogLegacyQuery(values, "q") || "";
  const encodedQ = encodeQueryValue(q);
  let sortstring = "";
  if (sort) {
    let sortArray = [];
    let sortSubArray = [];
    Object.keys(sort).map(function (key, index) {
      if (Object.keys(sort[key]).length > 0) {
        Object.keys(sort[key]).map(function (subkey, subindex) {
          sortSubArray[subindex] = `sort[${key}.${subkey}]=${sort[key][subkey]}`;
        });
      }
      if (key != "category") {
        sortArray[index] = `sort[${key}]=${sort[key]}`;
      }
    });
    if (sortSubArray.length > 0) {
      let jsubsort = sortSubArray.join("&");
      sortstring = jsubsort;
    }
    if (sortArray.length > 0) {
      let jsort = sortArray.join("&");
      sortstring = jsort;
    }
  }
  let pagination = true;
  if (values) {
    if (values.id) {
      pagination = false;
    }
    if (values.option) {
      pagination = false;
    }
    if (Object.prototype.hasOwnProperty.call(values, "pagination")) {
      pagination = values.pagination;
    }
  }
  const query = [sortstring, q ? `q=${encodedQ}` : ""].filter(Boolean).join("&");
  const action = localCatalogAction("afterlogin/services/view", values, query);
  let servicedata;
  if (dropdown) {
    servicedata = {
      pagination: false, //true or false
      id: "",
      // field: "name,description,duration,padding_time,color,service_booked_online,deposit_booked_online,deposit_booked_price", // first_name,last_name,email
      result: result, //business_name,owner_name
      pagetype: pagetype,
      formName
    };
  } else {
    servicedata = {
      pagination: pagination, //true or false
      id: values && values.id ? values.id : "",
      // field: values && values.id ? "" : "name,description,duration,padding_time,color,service_booked_online,deposit_booked_online,deposit_booked_price", // first_name,last_name,email
      result: result, //business_name,owner_name
      option: values && values.option ? values.option : "",
      category_id: values && values.category_id ? values.category_id : "",
      pagetype: pagetype,
      formName
    };
    if (hasValue(fromPosition)) servicedata.fromPosition = fromPosition;
    if (hasValue(toPosition)) servicedata.toPosition = toPosition;
    if (q) {
      servicedata.apicall = "suggetion";
      servicedata.q = q;
    }
  }

  const limit = catalogListLimit(values);
  if (limit) servicedata.limit = limit;

  // The calendar scopes its service dropdown to the selected staff member so
  // the list matches Staff -> Services assignments (SOF-426 issue 03).  Only
  // forward the filter when a staff id is actually present.
  if (values && values.staff_id) servicedata.staff_id = values.staff_id;

  const data = servicedata;
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const deleted = (values) => {
  const action = `afterlogin/services/delete/${values.id}`;
  const data = {};
  return axios.post(API_URL + action, data, { headers: authHeader(), ...(values.archive === true ? { deleteConfirmation: false } : {}) });
};

const suggetionlist = (values) => {
  let q = typeof (values && values.q) === "string" ? values.q : catalogLegacyQuery(values, "q") || "";
  const encodedQ = encodeQueryValue(q);
  const action = localCatalogAction("afterlogin/services/view", values, `q=${encodedQ}`);
  const data = {
    pagination: true, //true or false
    id: values && values.id ? values.id : "",
    // field: values && values.id ? "" : "name,description,duration,padding_time,color,service_booked_online,deposit_booked_online,deposit_booked_price", // first_name,last_name,email
    apicall: "suggetion",
    q,
  };
  const limit = catalogListLimit(values);
  if (limit) data.limit = limit;
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const addonservices = (values) => {
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  let isNotId = values && values.isNotId ? values.isNotId : "";
  const action = page ? `afterlogin/services/addonservices?page=${page}&isNotId=${isNotId}` : `afterlogin/services/addonservices?isNotId=${isNotId}`;
  const data = {
    isNotId,
  };
  return axios.post(next_page_url ? `${next_page_url}` : API_URL + action, data, { headers: authHeader() });
};

const addonstaff = (values) => {
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  let service_id = values && values.service_id ? values.service_id : "";
  const action = page ? `afterlogin/services/addonstaff?page=${page}&service_id=${service_id}` : `afterlogin/services/addonstaff?service_id=${service_id}`;
  const data = {
    service_id,
  };
  return axios.post(next_page_url ? `${next_page_url}` : API_URL + action, data, { headers: authHeader() });
};

const serviceprice = (values) => {
  let service_id = values && values.service_id ? values.service_id : "";
  let staff_id = values && values.staff_id ? values.staff_id : "";
  const action = `afterlogin/services/serviceprice`;
  const data = {
    service_id: service_id,
    staff_id: staff_id,
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const addonservicesfield = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  let service_id = values && values.service_id ? values.service_id : "";
  let add_on_service_id = values && values.add_on_service_id ? values.add_on_service_id : "";
  let isNotId = values && values.isNotId ? values.isNotId : "";
  const action = page ? `afterlogin/addon/services?page=${page}&isNotId=${isNotId}` : `afterlogin/addon/services?isNotId=${isNotId}`;
  const data = {
    auth_key: auth_key,
    action: action,
    service_id: service_id,
    add_on_service_id: add_on_service_id,
  };
  return axios.post(next_page_url ? `${next_page_url}` : API_URL + action, data, { headers: authHeader() });
};

const addonserviceprice = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  let service_id = values && values.service_id ? values.service_id : "";
  let staff_id = values && values.staff_id ? values.staff_id : "";
  let add_on_service_id = values && values.add_on_service_id ? values.add_on_service_id : "";
  let index_id = values && values.index_id ? values.index_id : "";
  const action = `afterlogin/addon/serviceprice`;
  const data = {
    auth_key: auth_key,
    action: action,
    service_id: service_id,
    staff_id: staff_id,
    add_on_service_id: add_on_service_id,
    index_id: index_id,
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const resourceviews = (values) => {
  // Extract parameters from the 'values' object
  void (values && values.page);
  const next_page_url = values && values.next_page_url;
  const result = values && values.result ? values.result : "";
  const user_id = values && values.user_id ? values.user_id  :"";
  const label = values && values.label ? values.label  :"";
  void (values && values.q ? values.q : "");
  const action = "afterlogin/resource/view";

  // Create the 'data' object to be sent in the request
  const data = {
    pagination: false,
    id: values && values.id ? values.id : "",
    service_id: values && values.service_id ? values.service_id : "",
    option: values && values.option ? values.option : "",
    user_id: user_id,
    label: label,
    result: result,
  };

  return axios.post(next_page_url ? `${next_page_url}` : API_URL + action, data, { headers: authHeader() });
};

const incompatibilities = () => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = "afterlogin/services/incompatibilities";
  return axios.post(API_URL + action, { auth_key: auth_key, action: action }, { headers: authHeader() });
};

const saveIncompatibilities = (values = {}) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = "afterlogin/services/incompatibilities/save";
  const ids = Array.isArray(values.incompatible_service_ids) ? values.incompatible_service_ids : [];
  const data = {
    service_id: values.service_id,
    incompatible_service_ids: JSON.stringify(ids),
    auth_key: auth_key,
    action: action,
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const serviceApiController = {
  create,
  update,
  view,
  deleted,
  suggetionlist,
  addonservices,
  addonstaff,
  serviceprice,
  addonservicesfield,
  addonserviceprice,
  resourceviews,
  incompatibilities,
  saveIncompatibilities,
};
export default serviceApiController;
